(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-quantity-breaks"] && !Shopify.designMode) return;
  try {
    class BundleQuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.tiers = Array.from(this.querySelectorAll('.bundle-tier'));
      this.tiers.forEach((tier) => {
        tier.addEventListener('click', () => this.selectTier(tier));
      });
      // Activate first tier by default
      if (this.tiers.length > 0) {
        this.tiers[0].setAttribute('aria-pressed', 'true');
      }
    }

    selectTier(tier) {
      // Update visual state
      this.tiers.forEach((t) => t.setAttribute('aria-pressed', 'false'));
      tier.setAttribute('aria-pressed', 'true');

      const qty = parseInt(tier.dataset.qty, 10) || 1;

      // Walk up the DOM to find product-form-component, then the form inside it
      const productFormComponent =
        this.closest('product-form-component') ||
        document.querySelector('product-form-component');

      let quantityInput = null;
      if (productFormComponent) {
        quantityInput = productFormComponent.querySelector('input[name="quantity"]');
      }
      // Fallback: find quantity input in the nearest form or anywhere on page
      if (!quantityInput) {
        const form =
          this.closest('form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (form) quantityInput = form.querySelector('input[name="quantity"]');
      }
      if (!quantityInput) {
        quantityInput = document.querySelector('input[name="quantity"]');
      }

      if (quantityInput) {
        quantityInput.value = qty;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Free-shipping badge logic: show tag if tier total >= R1000
      const basePrice = parseInt(this.dataset.basePrice, 10) || 0;
      const total = basePrice * qty;
      document.querySelectorAll('.wyf-free-shipping-tag').forEach((el) => {
        el.style.display = total >= 100000 ? '' : 'none';
      });
    }
  }

  if (!customElements.get('bundle-quantity-breaks')) {
    customElements.define('bundle-quantity-breaks', BundleQuantityBreaks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["order-countdown"] && !Shopify.designMode) return;
  try {
    class OrderCountdown extends HTMLElement {
    connectedCallback() {
      this.timerEl = this.querySelector('[data-role="timer"]');
      this.dateEl = this.querySelector('[data-role="date"]');
      this.render();
      this.interval = setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    render() {
      const now = new Date();
      const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      let diffMs = endOfDay - now;
      if (diffMs < 0) diffMs = 0;
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      if (this.timerEl) {
        this.timerEl.textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      }
      if (this.dateEl) {
        this.dateEl.textContent = this.estimateDeliveryDate(now);
      }
    }

    estimateDeliveryDate(from) {
      // 11 working days from today via Aramex, skipping Saturdays/Sundays
      let date = new Date(from);
      let daysToAdd = 11;
      while (daysToAdd > 0) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) daysToAdd -= 1;
      }
      return date.toLocaleDateString('en-ZA', { day: 'numeric', month: 'long' });
    }
  }

  if (!customElements.get('order-countdown')) {
    customElements.define('order-countdown', OrderCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
